import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

export default class IntercomController extends BridgeComponent {
  static component = "intercom";

  connect() {
    super.connect();
  }

  identify({userId, email, name}) {
    this.send("identify", { userId: userId.toString(), email, name });
  }

  logout() {
    this.send("logout", {});
  }
}
